import { registerSystem, System } from "aframe";

/*

"orientation" system : handles coordinates conversion for rotated scene canvas (through css transform)

*/

export interface OrientationSystem extends System
{
	data : string;
	convertCoordinates( source : { clientX : number, clientY : number } ) : { x : number, y : number }
}

registerSystem("orientation", {

	schema : { type : "string" },

	convertCoordinates(this : OrientationSystem, source : { clientX : number, clientY : number } )
	{
		if(this.data == "portrait")
			return {
				x : source.clientY - this.el.clientTop,
				y : (this.el.clientLeft + this.el.clientHeight) - source.clientX
			};

		return { x : source.clientX - this.el.clientLeft, y : source.clientY - this.el.clientTop };
	}
});